module.exports = __webpack_public_path__ + "static/media/veer.1aca05b2.jpg";